import React from "react";
import {withRouter} from "react-router";

import {Auth} from "@digatex/digatex-ui-lib";
import {Button, Modal} from "antd";

function NoPermissionModalBase({requiredApi, landingPath, onGoToLanding, location}) {
	const tokenParsed = Auth.tokenParsed();
	const roles = tokenParsed?.resource_access?.[requiredApi]?.roles ?? [];
	const hasPermission = roles.length > 0;
	const isLandingPage = landingPath && location.pathname.startsWith(landingPath);

	if (hasPermission || isLandingPage) {
		return null;
	}

	return (
		<Modal
			visible={true}
			closable={false}
			maskClosable={false}
			title="Access Restricted"
			maskStyle={{backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)"}}
			footer={
				<div style={{display: "flex", justifyContent: "space-between"}}>
					<Button key="landing" onClick={onGoToLanding}>
						Go to Landing
					</Button>
					<Button key="logout" type="primary" onClick={() => Auth.logout()}>
						Log out
					</Button>
				</div>
			}>
			<p>You don't have permission to view this page. Please contact your administrator.</p>
		</Modal>
	);
}

export const NoPermissionModal = withRouter(NoPermissionModalBase);
